export const LANGGRAPH_INTEGRATION_NAME = 'LangGraph';
export const LANGGRAPH_ORIGIN = 'auto.ai.langgraph';
